import * as React from 'react';
export const globalElements = {};
export const globalComponents = {};
export function registerAtaComponents(key: string, CustomComponent: any) {
  globalComponents[key] = React.memo(
    CustomComponent,
    (prevProps, nextProps) => {
      if (Object.is(prevProps, nextProps)) {
        return true;
      }
      try {
        const prevStr = JSON.stringify(prevProps);
        const nextStr = JSON.stringify(nextProps);
        if (Object.is(prevStr, nextStr)) {
          return true;
        }
      } catch (error) {
        return false;
      }
      return false;
    }
  );
}

export function execAtaComponent(key: string, param: object) {
  if (globalComponents[key]) {
    const MemoComponent = globalComponents[key];
    return <MemoComponent {...param} />;
  }
}
